import React, { useState, useEffect, useContext } from "react";
import { Redirect, Link, withRouter, useLocation } from "react-router-dom";
import { Dropdown, Menu, Table, notification, Modal, Icon } from "antd";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

import { GlobalContext } from "../../../../app/providers/GlobalState";

import DrawerAvalicao from "../../Drawer/DrawerAvalicao";
import ModalFichaGrupo from "../../Modal/ModalFichaGrupo";
import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
import ModalGerarDocumento from "../../../../shared/components/Modals/GerarDocumentoMultisseriado";
import ModalAta from "../../Relatorios/Drawer/AtaNotasGrupo";

import { useMediaQuery } from "react-responsive";

import { Teacher, Eye } from "iconsax-react";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Pautas = ({ estruturaId, periodo, tipo, match }) => {
    const disciplinaId =
        localStorage.getItem("vista") === "TURMA"
            ? localStorage.getItem("disciplina_aproveitamento")
            : localStorage.getItem("codigo_curso");

    const context = useContext(GlobalContext);
    const [avaliacoes, setAvalicoes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [pautaId, setPautaId] = useState(0);
    const [bloqueada, setBloqueada] = useState(false);
    const [visible, setVisible] = useState(false);
    const [expandedRows, setExpandedRows] = useState([]);
    const [notasGrupoEmMassaVisible, setNotasGrupoEmMassaVisible] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [avaliacaoEI, setAvaliacaoEI] = useState(false);
    const [grupoSelecionado, setGrupoSelecionado] = useState("");

    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [turmasProgresso, setTurmasProgresso] = useState();

    //MODAL
    const [visibleModal, setVisibleModal] = useState(false);
    const [turmasMultisseriado, setTurmasMultisseriado] = useState();

    //MODAL
    const [modalVisible, setModalVisible] = useState(false);
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [docs, setDocs] = useState([]);

    const acesso = context.acessos?.find(x => x.func === 21);
    const acessoValidar = context.acessos?.find(x => x.func === 23);
    const acessoInvalidar = context.acessos?.find(x => x.func === 24);

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const entidade = localStorage.getItem("entidade_id");

    const location = useLocation();

    const listar = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/aproveitamento/listar-items-avaliacao-conceitos",
            params: {
                disciplinaId: disciplinaId,
                estruturaId: estruturaId
            }
        })
            .then(response => {
                let avaliacoes = [];

                response.data.map(item => {
                    avaliacoes.push({
                        key: item.id,
                        id: item.id,
                        code: item.code,
                        epoca: item.epoca,
                        nome: item.titulo,
                        ordem: item.ordem,
                        campoCalculado: item.campoCalculado,
                        opcoes: (
                            <div className="tabela-opcoes-bimestre" style={{ justifyContent: "center" }}>
                                {!isTabletOrMobile && (
                                    <>
                                        <Link
                                            to="#"
                                            className="botao-avaliacoes-visualizar"
                                            title="Visualizar"
                                            onClick={() => {
                                                gerarDocumento(item);
                                                setGrupoSelecionado(item.id);
                                            }}
                                        >
                                            <Eye size="24" color="#FFFFFF" />
                                            Visualizar
                                        </Link>
                                        <Link
                                            to={`/gerir-multisseriado/${match.params.turma
                                                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                                .toLowerCase()}/aproveitamento-conceitos-lista-alunos`}
                                            className="botao-avaliacoes-alunos"
                                            title="Alunos"
                                            onClick={() => {
                                                localStorage.setItem("grupo", JSON.stringify({ id: item.id, nome: item.titulo }));
                                                localStorage.setItem(
                                                    "aproveitamento",
                                                    JSON.stringify({
                                                        estrutura: estruturaId,
                                                        periodo: periodo,
                                                        tipo: tipo
                                                    })
                                                );
                                            }}
                                        >
                                            <Teacher size="24" color="#FFFFFF" />
                                            Alunos
                                        </Link>
                                    </>
                                )}
                            </div>
                        )
                    });
                });

                setLoading(false);
                setAvalicoes(avaliacoes);

                localStorage.setItem("grupos", JSON.stringify(response.data.map(x => ({ id: x.id, nome: x.titulo }))));
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    };

    const listarsubItems = (expanded, record) => {
        const expandedKeys = [...expandedRows];
        if (expanded) {
            expandedKeys.push(record.key);
        } else {
            const index = expandedKeys.indexOf(record.key);
            if (index !== -1) {
                expandedKeys.splice(index, 1);
            }
        }
        setExpandedRows(expandedKeys);

        if (expanded)
            axios({
                method: "get",
                url: "/api/aproveitamento/listar-items-avaliacao-conceitos-subitems",
                params: {
                    grupoId: record.id
                }
            })
                .then(response => {
                    let lista = [];

                    response.data.map(item => {
                        let data = "";
                        let autor = "";
                        let estado = "";

                        if (item.guardado) {
                            data = moment(item.dt_guardado).format("DD/MM/YYYY");
                            autor = item.autor_guardado;
                            estado = "Por publicar";
                        }

                        if (item.publicado) {
                            data = moment(item.dt_publicado).format("DD/MM/YYYY");
                            autor = item.autor_publicado;
                            estado = "Publicado";
                        }

                        if (item.validado) {
                            data = moment(item.dt_validado).format("DD/MM/YYYY");
                            autor = item.autor_validado;
                            estado = "Validado";
                        }

                        lista.push({
                            key: item.id,
                            id: item.id,
                            code: item.code,
                            epoca: item.epoca,
                            nome: item.titulo,
                            autor: autor,
                            data: data,
                            //estado: estado,
                            ordem: item.ordem,
                            campoCalculado: item.campoCalculado
                        });
                    });

                    var tempAvaliacoes = avaliacoes;
                    var index = tempAvaliacoes.findIndex(x => x.id === record.id);
                    tempAvaliacoes[index].subItems = lista;
                    setAvalicoes([...tempAvaliacoes]);
                })
                .catch(error => {
                    if (error.response.data) openNotificationWithIcon("error", "Erro", error.response.data);
                });
    };

    const isRowExpanded = record => {
        return expandedRows.includes(record.key);
    };

    const publicar = pautaId => {
        confirm({
            title: "Pretende publicar os resultados?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                let item = new FormData();
                item.append("disciplinaId", disciplinaId);
                item.append("pautaId", pautaId);

                axios({
                    method: "put",
                    url: "/api/turma/publicar-pauta",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", response.data);
                        listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível publicar os resultados.");
                    });
            }
        });
    };

    const invalidar = pautaId => {
        confirm({
            title: "Pretende invalidar esta avaliação?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/aproveitamento/invalidar",
                    params: {
                        pautaId
                    }
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", response.data);
                        listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    });
            }
        });
    };

    const montarMenu = pauta => {
        return (
            <Menu>
                {isTabletOrMobile && (
                    <Menu.Item>
                        <Link
                            to="#"
                            // className="botao-icon-detalhe"
                            title="Visualizar"
                            onClick={() => gerarDoc(pauta.id)}
                        >
                            Visualizar
                        </Link>
                    </Menu.Item>
                )}
                {isTabletOrMobile && (
                    <Menu.Item>
                        <Link
                            to={`/gerir-multisseriado/${match.params.turma
                                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                .toLowerCase()}/aproveitamento-conceitos-lista-alunos`}
                            // className="botao-icon-adicionar"
                            title="Alunos"
                            onClick={() => {
                                localStorage.setItem("grupo", JSON.stringify({ id: pauta.id, nome: pauta.titulo }));
                                localStorage.setItem(
                                    "aproveitamento",
                                    JSON.stringify({
                                        estrutura: estruturaId,
                                        periodo: periodo,
                                        tipo: tipo
                                    })
                                );
                            }}
                        >
                            Alunos
                        </Link>
                    </Menu.Item>
                )}

                {!pauta.publicado && !pauta.validado && acesso?.update && (
                    <Menu.Item>
                        <Link to="#" onClick={() => publicar(pauta.id)}>
                            Publicar
                        </Link>
                    </Menu.Item>
                )}
                {pauta.publicado && !pauta.validado && acessoValidar && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setPautaId(pauta.id);
                                setVisibleModal(true);
                            }}
                        >
                            Validar
                        </Link>
                    </Menu.Item>
                )}
                {pauta.validado && acessoInvalidar && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                invalidar(pauta.id);
                            }}
                        >
                            Invalidar
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const onRowClick = (epoca, grupoId, grupo, record) => {
        localStorage.setItem(record.code, JSON.stringify({ epoca, grupoId, grupo, pauta: record.nome }));
        setRedirectLink(
            `/gerir-multisseriado/${match.params.turma
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}/aproveitamento-bncc-pautas/${record.code}`
        );
        setRedirect(true);

        localStorage.setItem(
            "aproveitamento",
            JSON.stringify({
                estrutura: estruturaId,
                periodo: periodo,
                tipo: tipo
            })
        );
    };

    const montarCores = estado => {
        if (estado === "Por publicar") return <span className="pauta-estado estado-por-publicar">Por publicar</span>;

        if (estado === "Publicado") return <span className="pauta-estado estado-publicado">Publicado</span>;

        if (estado === "Validado") return <span className="pauta-estado estado-validado">Validado</span>;

        return null;
    };

    const turmas = () => {
        axios({
            method: "get",
            url: "/api/gerir-turma/carregar-header-info",
            params: {
                cursoid: disciplinaId
            }
        })
            .then(response => {
                const dados = response.data.multisseriados.map(dado => ({
                    ...dado,
                    value: dado.disciplina.id,
                    label: dado.nome,
                    turmaId: dado.disciplina.id,
                    cursoId: dado.id
                }));

                setTurmasMultisseriado(dados);

                // Define a opção inicial selecionada com base no localStorage
                const codigoCurso = Number(localStorage.getItem("codigo_curso"));
                const inicialSelecionada = dados.filter(x => x.id === codigoCurso).map(x => x.id);
                setSelectedOptions(inicialSelecionada);

                localStorage.setItem("selectedOptions", JSON.stringify(inicialSelecionada));
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    // setRedirectLink("/login");
                    // setRedirect(true);
                }
            });
    };

    const isEnsinoInfantil = async () => {
        try {
            const response = await axios.get("/api/turma/verificar-categoria", {
                params: {
                    cursoId: disciplinaId
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao verificar categoria:", error);
            return null;
        }
    };

    useEffect(() => {
        listar();
        turmas();
    }, [estruturaId, location.pathname, disciplinaId]);

    const columns = [
        {
            title: "Época",
            dataIndex: "epoca",
            className: "bold-field"
        },
        {
            title: "Conceito",
            dataIndex: "nome",
            className: "bold-field",
            render: (text, record) => text
        },

        {
            title: "",
            dataIndex: "opcoes",
            width: 100
        }
    ];

    const expandedRowRender = record => {
        const columns = [
            {
                title: "Conceito",
                dataIndex: "nome",
                render: (text, record) => text
            }
        ];

        return (
            <Table
                id="disciplinas"
                className="tabela-sem-header"
                columns={columns}
                dataSource={record.subItems}
                pagination={false}
                locale={{ emptyText: "Não existem dados!" }}
                rowClassName={acesso?.read ? "clickeble-row" : ""}
                onRow={record2 => {
                    return {
                        onClick: acesso?.read ? () => onRowClick(record.epoca, record.id, record.nome, record2) : () => {}
                    };
                }}
            />
        );
    };

    const gerarDoc = grupoId => {
        setVisibleLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/notas-grupo",
            params: {
                cursoId: disciplinaId,
                grupoId
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
                setVisibleLoading(false);
            })
            .catch(error => {
                //if (error.response.data)
                //    openNotificationWithIcon("error", "Erro", error.response.data);

                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
                setVisibleLoading(false);
            });
    };

    const carregarNotasGruposEmMassa = async dataEmissao => {
        const uniqueFolderPath = uuidv4();

        setVisibleExportar(true);
        setBtnDescarregar(true);

        setTurmasProgresso(() => {
            const turmasSelecionadas = turmasMultisseriado
                .filter(turma => selectedOptions.includes(turma.turmaId))
                .map(turma => ({ ...turma, concluido: false })); // Reseta o progresso

            return turmasSelecionadas;
        });

        const selectedOptions = JSON.parse(localStorage.getItem("selectedOptions")) || [];

        try {
            for (let i = 0; i < selectedOptions.length; i++) {
                const cursoId = selectedOptions[i];

                await axios
                    .post("/api/pdf/notas-grupos-multisseriado-massa", {
                        cursoId: [cursoId],
                        grupoSelecionado: grupoSelecionado.toString(),
                        dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                        uniqueFolderPath: uniqueFolderPath
                    })
                    .then(response => {
                        setTurmasProgresso(prevTurmas => {
                            const newTurmas = [...prevTurmas];
                            const index = newTurmas.findIndex(turma => turma.turmaId === cursoId);
                            if (index !== -1) newTurmas[index].concluido = true;
                            return newTurmas;
                        });
                    });
            }

            await axios
                .get("/api/pdf/ficha-fundamental-multisseriado-zip", {
                    params: {
                        caminho: uniqueFolderPath
                    }
                })
                .then(response => {
                    setBtnDescarregar(false);
                    setFicheiroExportar(response.data.fileUrl);
                });
        } catch (error) {
            // Em caso de erro
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
            setVisibleExportar(false);
        }
    };

    const gerarDocumento = item => {
        const isEI = isEnsinoInfantil();

        if (entidade === "33" && isEI) {
            return setNotasGrupoEmMassaVisible(true);
        } else {
            return gerarDoc(item.id);
        }
    };

    if (redirect) return <Redirect to={redirectLink} />;
    return (
        <>
            <Table
                id="cursos-disciplinas"
                className="tabela-bimestre-multi-conseitos"
                loading={{
                    spinning: loading,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
                columns={columns}
                dataSource={avaliacoes}
                pagination={false}
                locale={{ emptyText: "Não existem dados!" }}
                onExpand={listarsubItems}
                rowClassName={(record, index) => (isRowExpanded(record) ? "parent-row-expanded" : "")}
                expandedRowRender={expandedRowRender}
            />
            <DrawerAvalicao
                pautaId={pautaId}
                bloqueada={bloqueada}
                ordem={avaliacoes.length > 0 ? avaliacoes[avaliacoes.length - 1].ordem + 1 : 1}
                visible={visible}
                onClose={() => setVisible(false)}
                atualizar={() => {
                    setVisible(false);
                    listar();
                }}
            />
            <ModalFichaGrupo
                grupoId={pautaId}
                visible={visibleModal}
                onClose={() => setVisibleModal(false)}
                atualizar={() => {
                    setVisibleModal(false);
                    listar();
                }}
            />
            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
                turmasMultisseriado={turmasProgresso}
            />

            <ModalAta //GERAR ZIP COM PDFS DA FICHA INDIVIDUAL
                visible={notasGrupoEmMassaVisible}
                onClose={() => setNotasGrupoEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarNotasGruposEmMassa(dataEmissao);
                    setNotasGrupoEmMassaVisible(false);
                }}
                turmasMultisseriado={turmasMultisseriado}
                selectedOptionsResultados={selectedOptions}
            />
        </>
    );
};
export default withRouter(Pautas);
